import { ConsentProviderPort } from '../../ports'
import {
  BroadcastPort,
  CONSENT_CHANGED_BROADCAST_EVENT,
} from '@otto-ec/eprivacy-shared'
import { archiveReceipt, emitConsentChangeEvent } from '@otto-ec/eprivacy-cmp'

export async function informClientOnConsentChanged(
  consentProvider: ConsentProviderPort,
  broadcastPort?: BroadcastPort
): Promise<void> {
  try {
    await archiveReceipt(consentProvider.getConsentId(), 'OneTrust-CB-Web')
  } catch (e) {
    console.log(e)
  } finally {
    broadcastPort?.send(CONSENT_CHANGED_BROADCAST_EVENT)
    await emitConsentChangeEvent()
  }
}
